import * as angular from "angular";
import {applyMiddleware, createStore, compose} from "redux";
import {default as reducers} from "../reducers";
import thunk from "redux-thunk";
import * as React from "react";
import {connect, Provider} from "react-redux";
import server from "../../../../integration/server/server-services";
import nvdbapi from "../../../../integration/nvdbapi/nvdbapi";
import security from "../../../../service/security/security-services";
import {EventlogState} from "../EventlogState";
import {ContractEvents} from "./Events";
import {initEventlog, InitEventlog} from "../actions";
import {ContractEventlogFiltering} from "./EventlogFiltering";

export class ServerHolder {
    constructor(
        public security: security = null,
        public server: server = null,
        public scope: angular.IRootScopeService = null,
        public nvdbapi: nvdbapi = null,
        public $q: angular.IQService = null,
        public contractId: string = null,
    ) {
    }
}

const serverHolder = new ServerHolder();

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, /* preloadedState, */ composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(serverHolder))
));

interface EventlogProps {
    server: server,
    security: security,
    nvdbapi: nvdbapi,
    $q: angular.IQService,
    $routeParams: angular.route.IRouteParamsService,
    $rootScope: angular.IRootScopeService,
    doInitEventlog: InitEventlog
}

interface StateProps {
    contractId: string
}

interface DispatchProps {
    doInitEventlog: InitEventlog
}

const mapDispatchToProps: DispatchProps = ({
    doInitEventlog: initEventlog
});

interface TagProps {
}

interface localState {
    isLoggedIn: boolean,
}

type Props = DispatchProps & StateProps & TagProps;

class EventlogView extends React.Component<Props, {}> {


    componentWillMount(): void {
        this.props.doInitEventlog(this.props.contractId);
    }

    render() {
        let {contractId} = this.props;


        return (
            <div className={"eventlog"}>

                <h1>Hendelseslogg</h1>
                <ContractEventlogFiltering />
                <ContractEvents />

            </div>
        );
    }
}


export class Eventlog extends React.Component<EventlogProps, {isLoggedIn: boolean}> {

    constructor(props: EventlogProps) {
        super(props);
        this.state = {
            isLoggedIn: false
        }
    }

    componentDidMount() {
        this.props.security.ensureCurrentUser().then(result => {
            this.setState(
                {
                    isLoggedIn: true,
                })
        })
    }

    render() {
        const mapStateToProps = (state: EventlogState): StateProps => {
            const contractId = this.props.$routeParams["contractId"];
            return {
                contractId: contractId,
            }
        };

        const mapDispatchToProps: DispatchProps = ({
            doInitEventlog: initEventlog
        });

        serverHolder.security = this.props.security;
        serverHolder.server = this.props.server;
        serverHolder.nvdbapi = this.props.nvdbapi;
        serverHolder.$q = this.props.$q;
        serverHolder.contractId = this.props.$routeParams["contractId"];
        serverHolder.scope = this.props.$rootScope;

        const LocationalComponent = connect(mapStateToProps, mapDispatchToProps)(EventlogView);

        // prevent mounting LocationalComponent if the user is not logged in.
        // this keeps the login-window clean and we ensure that the user is logged in before we query the API on mount.
        if (!this.state.isLoggedIn) {
            return null;
        }

        return (
            <Provider store={store} key="provider">
                <LocationalComponent />
            </Provider>
        )
    }
}
